;(function () {
  'use strict'

  angular
    .module('contrast.rules')
    .constant('RULES_EXPAND_PROPERTIES', ['references', 'customization'])
})()
